import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout-full',
  templateUrl: './layout-full.component.html'
})
export class LayoutFullComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
